import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStickNote = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12.3719 20.5714H7.24523C6.23515 20.5714 5.26318 20.1619 4.5485 19.4476C3.83382 18.7334 3.43359 17.7619 3.43359 16.7524V7.22858C3.43359 6.21906 3.83382 5.24762 4.55803 4.54286C5.27271 3.82857 6.23515 3.42859 7.24523 3.42859H16.7743C17.7844 3.42859 18.7564 3.82857 19.4615 4.54286C20.1667 5.25714 20.5765 6.21906 20.5765 7.22858V12.3619C20.5193 13.4857 20.0714 14.5524 19.3186 15.3905L15.4021 19.3143C14.5636 20.0667 13.4963 20.5143 12.3719 20.5714Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.8623 17.1429V14.4572C12.8623 14.0286 13.0353 13.6286 13.3428 13.3238C13.6407 13.0286 14.0635 12.8572 14.4863 12.8572H17.148",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round"
	})]
});
export default SvgStickNote;
